import { render, staticRenderFns } from "./AdditionalTrustors.vue?vue&type=template&id=688385e6&"
import script from "./AdditionalTrustors.vue?vue&type=script&lang=js&"
export * from "./AdditionalTrustors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/juhah/Documents/Projects/faa-generator/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VExpansionPanel,VFlex,VIcon,VLayout})
